import axios, { AxiosInstance } from "axios";
import { useAuthStore } from "@/stores/authStore";
import { useAuthSync } from "@/stores/useAuthSync";

const createApiInstance = (baseURL: string): AxiosInstance => {
  const api = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  api.interceptors.request.use((config) => {
    const token = useAuthStore.getState().getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  api.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalRequest = err.config;
      if (err.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          await useAuthSync().signinRedirect(); // * Triggers interactive renewal if silent fails
          originalRequest.headers.Authorization = `Bearer ${useAuthStore
            .getState()
            .getToken()}`;
          return api(originalRequest);
        } catch {
          useAuthSync().signoutRedirect();
        }
      }
      return Promise.reject(err);
    }
  );

  return api;
};

export { createApiInstance };
